var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6583B7"
    },
    d: "M467.478,417.391H44.522c-12.295,0-22.261-9.966-22.261-22.261V83.478 c0-12.295,9.966-22.261,22.261-22.261h422.957c12.295,0,22.261,9.966,22.261,22.261V395.13 C489.739,407.425,479.773,417.391,467.478,417.391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#819AD1"
    },
    d: "M489.739,83.478V244.87H22.261V83.478c0-12.295,9.966-22.261,22.261-22.261h422.957 C479.773,61.217,489.739,71.184,489.739,83.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M467.478,450.783H44.522C19.933,450.783,0,430.849,0,406.261l0,0C0,393.966,9.966,384,22.261,384 h467.478c12.295,0,22.261,9.966,22.261,22.261l0,0C512,430.849,492.066,450.783,467.478,450.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1C1C1"
    },
    d: "M489.739,384c7.175,0,13.539,3.409,17.611,8.68c-7.29,14.644-22.401,24.712-39.871,24.712H44.522 c-17.469,0-32.581-10.068-39.871-24.712c4.072-5.27,10.436-8.68,17.611-8.68H489.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M283.826,406.261h-55.652c-9.22,0-16.696-7.475-16.696-16.696l0,0c0-9.22,7.475-16.696,16.696-16.696 h55.652c9.22,0,16.696,7.475,16.696,16.696l0,0C300.522,398.786,293.047,406.261,283.826,406.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE5A3A"
    },
    d: "M261.565,217.043v111.304h-66.783V217.043c0-6.147,4.983-11.13,11.13-11.13h44.522 C256.582,205.913,261.565,210.896,261.565,217.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9D5E"
    },
    d: "M205.913,172.522v155.826H139.13V172.522c0-6.147,4.983-11.13,11.13-11.13h44.522 C200.93,161.391,205.913,166.374,205.913,172.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEF184"
    },
    d: "M161.391,272.696v55.652H94.609v-55.652c0-6.147,4.983-11.13,11.13-11.13h44.522 C156.408,261.565,161.391,266.548,161.391,272.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5D89"
    },
    d: "M297.739,328.348c0,4.61-3.738,8.348-8.348,8.348H66.783c-4.61,0-8.348-3.738-8.348-8.348 S62.172,320,66.783,320h222.609C294.002,320,297.739,323.738,297.739,328.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4E8FF"
    },
    d: "M325.565,200.348c0-4.61,3.738-8.348,8.348-8.348h100.174c4.61,0,8.348,3.738,8.348,8.348 c0,4.61-3.738,8.348-8.348,8.348H333.913C329.303,208.696,325.565,204.958,325.565,200.348z M434.087,236.522H333.913 c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h100.174c4.61,0,8.348-3.738,8.348-8.348S438.697,236.522,434.087,236.522 z M400.696,281.043h-66.783c-4.61,0-8.348,3.738-8.348,8.348s3.738,8.348,8.348,8.348h66.783c4.61,0,8.348-3.738,8.348-8.348 S405.306,281.043,400.696,281.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1C1C1"
    },
    d: "M489.739,83.478v22.261H22.261V83.478c0-12.295,9.966-22.261,22.261-22.261h422.957 C479.773,61.217,489.739,71.184,489.739,83.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB"
    },
    d: "M272.696,105.739c0,9.22-7.475,16.696-16.696,16.696s-16.696-7.475-16.696-16.696 S246.78,89.043,256,89.043S272.696,96.519,272.696,105.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M261.565,105.739c0,3.073-2.492,5.565-5.565,5.565s-5.565-2.492-5.565-5.565 c0-3.073,2.492-5.565,5.565-5.565S261.565,102.666,261.565,105.739z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.7a7b215f022160a4070685c5990c7c40.svg";
export { ForwardRef as ReactComponent };